// Module
var code = "<div ng-click=\"sortClick();\" style=\"width: 100%; height: 100%;\" ng-class=\"{'sort-asc': sortList.sort.key == sortKey && sortList.sort.direction == -1, 'sort-desc': sortList.sort.key == sortKey && sortList.sort.direction == 1}\">\n    <span ng-transclude></span>\n</div>\n\n";
// Exports
module.exports = code;